import {createFileRoute} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PractitionerCreate from '@/practitioner/views/practitioner/PractitionerCreate';

export const Route = createFileRoute('/(practitioner)/company/practitioners/create')({
  component: PractitionerCreate,
  beforeLoad: grantUser(practitionerAdminGranted)
});
